import { ExportButton } from '@/common/buttons/ExportButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

export const TrxViewer = () => {

  const { trxSrcCode } = useParams();
  const { navState } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const gridRef = useRef();

  const [title, setTitle] = useState('');
  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  useEffect(() => {
    rsrc.data('sc', 'ENUM_DATA_PLUGIN', { enumCode: 'TRX_SRC_CODE' }).then((trxSrcs) => {
      const trxSrcName = trxSrcs.find(trxSrc => 'TRX_' + trxSrc.code === trxSrcCode);
      setTitle(trxSrcName.displayName);
    })

    const reqParam = {
      ...navState.viewerReqParam,
      trxSrcCode: trxSrcCode
    }
    rsrc.viewerFieldDefs(module, 'TRX_VIEWER_PLUGIN', reqParam, trxSrcCode).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [])

  const buildAndSetExportReq = (reqParam) => {
    const exportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      displayName: title,
      module,
      entity: trxSrcCode,
      uiType: 'VIEWER',
      viewerPluginCode: 'TRX_VIEWER_PLUGIN',
      viewerReqParam: reqParam,
      fieldDefs,
    };
    setExportReq(exportReq);
  };

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {
        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);
        const reqParam = {
          ...navState.viewerReqParam,
          trxSrcCode: trxSrcCode,
          startRow: params.startRow,
          endRow: params.endRow,
          expr
        };

        buildAndSetExportReq(reqParam);

        rsrc.viewerRows(module, 'TRX_VIEWER_PLUGIN', reqParam, trxSrcCode).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        })

        rsrc.viewerCount(module, 'TRX_VIEWER_PLUGIN', reqParam, trxSrcCode).then(count => {
          gridRef.current.setCount(count);
        })

        rsrc.viewerAggTotals(module, 'TRX_VIEWER_PLUGIN', reqParam, trxSrcCode).then(aggTotals => {
          gridRef.current.setTotalsRow(aggTotals);
        })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  return (
    fieldDefs &&
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Title icon={far.faListUl} title={title} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <ExportButton exportReq={exportReq} />
        </Box>
      </Box>
      <Grid
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}
      />
    </>
  );
}